const translations = {
  "en": {
    "Active": "Active"
  },
  "zh-tw": {
    "Active": "最新部署"
  }
};

export default translations;
